import { useQuery } from "@tanstack/react-query"
import {
  getOrderStatistics,
  getOrderStatsForPatientIssuer,
} from "../api/statistics"
import { formatISODate } from "../utils/datetime"

export const useOrderStatistics = ({ sortBy, patientIssuer, from, to }) =>
  useQuery({
    queryKey: ["order-components", sortBy, patientIssuer, from, to],
    queryFn: () => getOrderStatistics({ sortBy, patientIssuer, from, to }),
    retry: false,
  })

export const useOrderStatsForPatientIssuer = ({ patientIssuer, from, to }) =>
  useQuery({
    queryKey: ["order-stats", patientIssuer, from, to],
    queryFn: () => getOrderStatsForPatientIssuer({ patientIssuer, from, to }),
    retry: false,
    select: (data) => data.map(toOrderStat),
  })

const dateTimeFormat = "MM/dd/yyyy HH:mm:ss a"
export const toOrderStat = (orderApiDto) => ({
  ...orderApiDto,
  orderSentToRamsoftAt: formatISODate(
    orderApiDto?.OrderSentToRSAt,
    dateTimeFormat
  ),
})
